import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Action from './Action';
import Match from './Match';
import MatchFinder from './MatchFinder';
import Operation from './Operation';
import MatchOptions from './MatchOptions';
import * as WordSplitter from './WordSplitter';
import * as Utils from './Utils'; // This value defines balance between speed and memory utilization. The higher it is the faster it works and more memory consumes.

var MatchGranuarityMaximum = 4;
var specialCaseClosingTags = new Map([['</strong>', 0], ['</em>', 0], ['</b>', 0], ['</i>', 0], ['</big>', 0], ['</small>', 0], ['</u>', 0], ['</sub>', 0], ['</strike>', 0], ['</s>', 0]]);
var specialCaseOpeningTagRegex = /<((strong)|(b)|(i)|(em)|(big)|(small)|(u)|(sub)|(sup)|(strike)|(s))[\>\s]+/ig;

var HtmlDiff =
/*#__PURE__*/
function () {
  function HtmlDiff(oldText, newText) {
    _classCallCheck(this, HtmlDiff);

    this.content = [];
    this.newText = newText;
    this.oldText = oldText;
    this.specialTagDiffStack = [];
    this.newWords = [];
    this.oldWords = [];
    this.matchGranularity = 0;
    this.blockExpressions = [];
    this.repeatingWordsAccuracy = 1.0;
    this.ignoreWhiteSpaceDifferences = false;
    this.orphanMatchThreshold = 0.0;
  }

  _createClass(HtmlDiff, [{
    key: "build",
    value: function build() {
      if (this.oldText === this.newText) {
        return this.newText;
      }

      this.splitInputsIntoWords();
      this.matchGranularity = Math.min(MatchGranuarityMaximum, this.oldWords.length, this.newWords.length);
      var operations = this.operations();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          this.performOperation(item);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.content.join('');
    }
  }, {
    key: "addBlockExpression",
    value: function addBlockExpression(exp) {
      this.blockExpressions.push(exp);
    }
  }, {
    key: "splitInputsIntoWords",
    value: function splitInputsIntoWords() {
      this.oldWords = WordSplitter.convertHtmlToListOfWords(this.oldText, this.blockExpressions); //free memory, allow it for GC

      this.oldText = null;
      this.newWords = WordSplitter.convertHtmlToListOfWords(this.newText, this.blockExpressions); //free memory, allow it for GC

      this.newText = null;
    }
  }, {
    key: "performOperation",
    value: function performOperation(opp) {
      switch (opp.action) {
        case Action.equal:
          this.processEqualOperation(opp);
          break;

        case Action["delete"]:
          this.processDeleteOperation(opp, "diffdel");
          break;

        case Action.insert:
          this.processInsertOperation(opp, "diffins");
          break;

        case Action.none:
          break;

        case Action.replace:
          this.processReplaceOperation(opp);
          break;
      }
    }
  }, {
    key: "processReplaceOperation",
    value: function processReplaceOperation(opp) {
      this.processDeleteOperation(opp, "diffmod");
      this.processInsertOperation(opp, "diffmod");
    }
  }, {
    key: "processInsertOperation",
    value: function processInsertOperation(opp, cssClass) {
      var text = this.newWords.filter(function (s, pos) {
        return pos >= opp.startInNew && pos < opp.endInNew;
      });
      this.insertTag("ins", cssClass, text);
    }
  }, {
    key: "processDeleteOperation",
    value: function processDeleteOperation(opp, cssClass) {
      var text = this.oldWords.filter(function (s, pos) {
        return pos >= opp.startInOld && pos < opp.endInOld;
      });
      this.insertTag("del", cssClass, text);
    }
  }, {
    key: "processEqualOperation",
    value: function processEqualOperation(opp) {
      var result = this.newWords.filter(function (s, pos) {
        return pos >= opp.startInNew && pos < opp.endInNew;
      });
      this.content.push(result.join(''));
    }
  }, {
    key: "insertTag",
    value: function insertTag(tag, cssClass, words) {
      while (words.length) {
        var nonTags = this.extractConsecutiveWords(words, function (x) {
          return !Utils.isTag(x);
        });
        var specialCaseTagInjection = '';
        var specialCaseTagInjectionIsbefore = false;

        if (nonTags.length !== 0) {
          var text = Utils.wrapText(nonTags.join(''), tag, cssClass);
          this.content.push(text);
        } else {
          if (specialCaseOpeningTagRegex.test(words[0])) {
            this.specialTagDiffStack.push(words[0]);
            specialCaseTagInjection = '<ins class="mod">';

            if (tag === 'del') {
              words.shift();

              while (words.length > 0 && specialCaseOpeningTagRegex.test(words[0])) {
                words.shift();
              }
            }
          } else if (specialCaseClosingTags.has(words[0])) {
            var openingTag = this.specialTagDiffStack.length === 0 ? null : this.specialTagDiffStack.pop();

            if (!(openingTag === null || openingTag !== words[0].replace(/\//g, ''))) {
              specialCaseTagInjection = '</ins>';
              specialCaseTagInjectionIsbefore = true;
            }

            if (tag === 'del') {
              words.shift();

              while (words.length > 0 && specialCaseClosingTags.has(words[0])) {
                words.shift();
              }
            }
          }

          if (words.length === 0 && specialCaseTagInjection.length === 0) {
            break;
          }

          if (specialCaseTagInjectionIsbefore) {
            this.content.push(specialCaseTagInjection + this.extractConsecutiveWords(words, Utils.isTag).join(''));
          } else {
            this.content.push(this.extractConsecutiveWords(words, Utils.isTag).join('') + specialCaseTagInjection);
          }
        }
      }
    }
  }, {
    key: "extractConsecutiveWords",
    value: function extractConsecutiveWords(words, condition) {
      var indexOfFirstTag = null;

      for (var i = 0; i < words.length; i++) {
        var word = words[i];

        if (i === 0 && word === ' ') {
          words[i] = '&nbsp;';
        }

        if (!condition(word)) {
          indexOfFirstTag = i;
          break;
        }
      }

      if (indexOfFirstTag !== null) {
        var items = words.filter(function (s, pos) {
          return pos >= 0 && pos < indexOfFirstTag;
        });

        if (indexOfFirstTag > 0) {
          words.splice(0, indexOfFirstTag);
        }

        return items;
      } else {
        var _items = words.filter(function (s, pos) {
          return pos >= 0 && pos < words.length;
        });

        words.splice(0, words.length);
        return _items;
      }
    }
  }, {
    key: "operations",
    value: function operations() {
      var positionInOld = 0;
      var positionInNew = 0;
      var operations = [];
      var matches = this.matchingBlocks();
      matches.push(new Match(this.oldWords.length, this.newWords.length, 0));
      var matchesWithoutOrphans = this.removeOrphans(matches);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = matchesWithoutOrphans[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var match = _step2.value;
          var matchStartsAtCurrentPositionInOld = positionInOld === match.startInOld;
          var matchStartsAtCurrentPositionInNew = positionInNew === match.startInNew;
          var action = void 0;

          if (!matchStartsAtCurrentPositionInOld && !matchStartsAtCurrentPositionInNew) {
            action = Action.replace;
          } else if (matchStartsAtCurrentPositionInOld && !matchStartsAtCurrentPositionInNew) {
            action = Action.insert;
          } else if (!matchStartsAtCurrentPositionInOld) {
            action = Action["delete"];
          } else {
            action = Action.none;
          }

          if (action !== Action.none) {
            operations.push(new Operation(action, positionInOld, match.startInOld, positionInNew, match.startInNew));
          }

          if (match.length !== 0) {
            operations.push(new Operation(Action.equal, match.startInOld, match.endInOld, match.startInNew, match.endInNew));
          }

          positionInOld = match.endInOld;
          positionInNew = match.endInNew;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return operations;
    }
  }, {
    key: "removeOrphans",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function removeOrphans(matches) {
      var prev, curr, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, next, tmp, sumLength, oldDistanceInChars, newDistanceInChars, currMatchLengthInChars;

      return _regeneratorRuntime.wrap(function removeOrphans$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              prev = null;
              curr = null;
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context.prev = 5;
              _iterator3 = matches[Symbol.iterator]();

            case 7:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context.next = 31;
                break;
              }

              next = _step3.value;

              if (!(curr === null)) {
                _context.next = 13;
                break;
              }

              prev = new Match(0, 0, 0);
              curr = next;
              return _context.abrupt("continue", 28);

            case 13:
              if (!(prev.endInOld === curr.startInOld && prev.endInNew === curr.startInNew || curr.endInOld === next.startInOld && curr.endInNew === next.startInNew)) {
                _context.next = 19;
                break;
              }

              _context.next = 16;
              return curr;

            case 16:
              tmp = prev = curr; // "let tmp" avoids babel traspiling error

              curr = next;
              return _context.abrupt("continue", 28);

            case 19:
              sumLength = function sumLength(t, n) {
                return t + n.length;
              };

              oldDistanceInChars = this.oldWords.slice(prev.endInOld, next.startInOld).reduce(sumLength, 0);
              newDistanceInChars = this.newWords.slice(prev.endInNew, next.startInNew).reduce(sumLength, 0);
              currMatchLengthInChars = this.newWords.slice(curr.startInNew, curr.endInNew).reduce(sumLength, 0);

              if (!(currMatchLengthInChars > Math.max(oldDistanceInChars, newDistanceInChars) * this.orphanMatchThreshold)) {
                _context.next = 26;
                break;
              }

              _context.next = 26;
              return curr;

            case 26:
              prev = curr;
              curr = next;

            case 28:
              _iteratorNormalCompletion3 = true;
              _context.next = 7;
              break;

            case 31:
              _context.next = 37;
              break;

            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](5);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t0;

            case 37:
              _context.prev = 37;
              _context.prev = 38;

              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }

            case 40:
              _context.prev = 40;

              if (!_didIteratorError3) {
                _context.next = 43;
                break;
              }

              throw _iteratorError3;

            case 43:
              return _context.finish(40);

            case 44:
              return _context.finish(37);

            case 45:
              _context.next = 47;
              return curr;

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, removeOrphans, this, [[5, 33, 37, 45], [38,, 40, 44]]);
    })
  }, {
    key: "matchingBlocks",
    value: function matchingBlocks() {
      var matchingBlocks = [];
      this.findMatchingBlocks(0, this.oldWords.length, 0, this.newWords.length, matchingBlocks);
      return matchingBlocks;
    }
  }, {
    key: "findMatchingBlocks",
    value: function findMatchingBlocks(startInOld, endInOld, startInNew, endInNew, matchingBlocks) {
      var match = this.findMatch(startInOld, endInOld, startInNew, endInNew);

      if (match !== null) {
        if (startInOld < match.startInOld && startInNew < match.startInNew) {
          this.findMatchingBlocks(startInOld, match.startInOld, startInNew, match.startInNew, matchingBlocks);
        }

        matchingBlocks.push(match);

        if (match.endInOld < endInOld && match.endInNew < endInNew) {
          this.findMatchingBlocks(match.endInOld, endInOld, match.endInNew, endInNew, matchingBlocks);
        }
      }
    }
  }, {
    key: "findMatch",
    value: function findMatch(startInOld, endInOld, startInNew, endInNew) {
      for (var i = this.matchGranularity; i > 0; i--) {
        var options = new MatchOptions();
        options.blockSize = i;
        options.repeatingWordsAccuracy = this.repeatingWordsAccuracy;
        options.ignoreWhitespaceDifferences = this.ignoreWhiteSpaceDifferences;
        var finder = new MatchFinder(this.oldWords, this.newWords, startInOld, endInOld, startInNew, endInNew, options);
        var match = finder.findMatch();

        if (match !== null) {
          return match;
        }
      }

      return null;
    }
  }]);

  return HtmlDiff;
}();

HtmlDiff.execute = function (oldText, newText) {
  return new HtmlDiff(oldText, newText).build();
};

export default HtmlDiff;